<template>
  <el-container>
    <hic-table :entities="myEntities" :condition="condition" @selection-change="selectionChange" :loading="loading" @load="page" :no-merge-fields="['医嘱内容']" :cell-class-name="styleClass">
      <el-table-column align="center" width="10"></el-table-column>
      <el-table-column v-if="!readonly" align="center" type="selection" :selectable="selectable" width="55" label="" key="selecton" />
      <el-table-column v-if="!readonly" align="center" label="操作" width="150">
        <template #default="{ row }">
          <el-button v-if="btnProofDisplay(row)" type="warning" size="small" @click="$emit('confirm', [row.id])" round plain style="border-bottom: 5px solid #e6a23c">
            <span>{{ row.no }}</span>
            <br />
            <b>校 对</b>
          </el-button>
          <el-dropdown v-if="btnExecDisplay(row) || btnStopDisplay(row)" @command="(e) => execCommand(e, row)" :show-timeout="1000" placement="bottom">
            <el-button v-if="btnStopDisplay(row)" type="danger" size="small" @click="$emit('action', '确认停止', [row.id])" round plain style="border-bottom: 5px solid #f56c6c">
              <span>{{ row.no }}</span>
              <br />
              <b>停 止</b>
            </el-button>
            <el-button v-else type="success" size="small" @click="exec(row)" round plain style="border-bottom: 5px solid #67c23a" :disabled="canNotExec(row)">
              <span>{{ row.no }}</span>
              <br />
              <b>执 行</b>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="!setting.isSimple" command="记账" icon="el-icon-money" class="danger">补充记账</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
      <template v-if="!isEmbed">
        <el-table-column align="left" label="床位" prop="bedNo" width="150" sortable="custom" key="bedNo">
          <template #default="{ row }">
            <span class="sub-title">{{ row.bedNo }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="患者" prop="patientName" width="130" key="patientName">
          <template #default="{ row }">
            <span>{{ row.patientName }}</span>
          </template>
        </el-table-column>
      </template>
      <el-table-column :filters="stateOptions" :filtered-value="filterStates" column-key="states" align="center" width="100" label="状态" prop="state" key="state">
        <template #default="{ row }">
          <el-button v-if="row.state == '启用'" type="success" size="small" @click="showLogs(row)">{{ row.state }}</el-button>
          <el-button v-else-if="row.state == '待校对'" type="warning" size="small" @click="showLogs(row)">{{ row.state }}</el-button>
          <el-button v-else-if="row.state == '待停止'" type="danger" size="small" @click="showLogs(row)">{{ row.state }}</el-button>
          <el-button v-else-if="row.state == '草稿'" type="primary" size="small" @click="showLogs(row)">{{ row.state }}</el-button>
          <el-button v-else-if="row.state == '废弃'" type="info" size="small" @click="showLogs(row)" plain>{{ row.state }}</el-button>
          <el-button v-else-if="row.state == '退回'" type="danger" size="small" @click="showLogs(row)">{{ row.state }}</el-button>
          <el-button v-else type="info" size="small" @click="showLogs(row)">{{ row.state }}</el-button>
        </template>
      </el-table-column>
      <el-table-column :filters="dictEnum.AdviceType" :filter-multiple="false" column-key="type" align="center" width="100" label="类型" prop="type" key="type">
        <template #default="{ row }">
          <el-tag v-if="row.type == '药品'" type="primary" size="small" hit effect="plain">{{ row.type }}</el-tag>
          <el-tag v-else-if="row.type == '草药'" type="warning" size="small" hit effect="plain">{{ row.type }}</el-tag>
          <el-tag v-else-if="row.type == '医技'" type="danger" size="small" hit effect="plain">{{ row.type }}</el-tag>
          <el-tag v-else-if="row.type == '嘱托'" type="info" hit size="small">{{ row.type }}</el-tag>
          <el-tag v-else-if="row.type == '护理'" type="success" hit size="small">{{ row.type }}</el-tag>
          <el-tag v-else type="danger" effect="light" hit size="small">{{ row.type }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column :filters="setting.isSimple ? [] : dictEnum.AdviceTerm" :filter-multiple="false" column-key="term" align="center" width="100" label="期效" prop="term" key="term">
        <!-- <el-table-column align="center" width="100" label="期效" prop="term" key="term"> -->
        <template #default="{ row }">
          <el-tag v-if="row.term == '长期'" type="success" size="small" hit>{{ row.term }}</el-tag>
          <el-tag v-else-if="row.term == '临时'" type="danger" size="small" hit>{{ row.term }}</el-tag>
          <el-tag v-else type="warning" size="small" hit>{{ row.term }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="left" width="600" label="医嘱内容" prop="name" key="name">
        <template #default="{ row }">
          <DrugInfo v-if="row.type == '药品'" :row="row" :isEdit="false" :readonly="true"> </DrugInfo>
          <MlInfo v-else-if="row.type == '医技'" :row="row" :isEdit="false" :readonly="true"> </MlInfo>
          <HerbalInfo v-else-if="row.type == '草药'" :row="row" :readonly="true"></HerbalInfo>
          <div v-else-if="row.type == '转科' || row.type == '离院'">
            <el-tag type="danger" hit style="border-left: 3rem solid #ff4949">
              <span style="margin-left: -3rem; color: white">{{ row.type }}</span>
              <span style="margin-left: 1.5rem">{{ row.content }}</span>
            </el-tag>
          </div>
          <template v-else>
            <div>{{ row.name }}</div>
          </template>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" align="center" width="100" label="开始时间" prop="startTime" key="startDate">
        <template #default="{ row }">
          <span>{{ row.startTime | fmtDate }}</span>
          <br />
          <span>{{ row.startTime | fmtTime }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" align="center" width="120" label="最近执行" prop="execTime" key="execTime">
        <template #default="{ row }">
          <span v-if="row.execTime">{{ row.execTime | fmtDate }}</span>
          <br />
          <span>{{ row.execTime | fmtTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="120" label="医保范围" prop="claimType" key="claimType">
        <template #default="{ row }">
          <el-tag v-if="row.claimType == '医保内'" type="success" size="small" hit effect="plain">{{ row.claimType }}</el-tag>
          <el-tag v-if="row.claimType == '医保外'" type="danger" size="small" hit effect="plain">{{ row.claimType }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="!setting.isSimple" align="center" width="60" label="出院带药" prop="ifHomeDrug" key="ifHomeDrug">
        <template #default="{ row }">
          <el-tag v-if="row.ifHomeDrug" type="danger" size="small" hit>是</el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="!setting.isSimple" align="center" width="60" label="长嘱临费" prop="ifOneTimeCharge" key="ifOneTimeCharge">
        <template #default="{ row }">
          <el-tag v-if="row.ifOneTimeCharge" type="danger" size="small" hit>是</el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="!setting.isSimple" align="center" width="60" label="备用" prop="ifStandby" key="ifStandby">
        <template #default="{ row }">
          <el-tag v-if="row.ifStandby" type="danger" size="small" hit>是</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" width="160" label="嘱托" prop="content" key="content" />

      <el-table-column align="center" width="150" label="执行科室" prop="" key="execDeptCode">
        <template #default="{ row }">
          <div>{{ row.execDeptCode | dictText("Dept") }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" width="100" label="开嘱医师" prop="doctorName" key="doctorName" />
      <el-table-column sortable="custom" align="right" width="100" label="停止时间" prop="stopTime" key="stopTime">
        <template #default="{ row }">
          <el-row v-if="row.stopTime || row.endTime">{{ (row.stopTime || row.endTime) | fmtDate }}</el-row>
          <el-row v-if="row.stopTime || row.endTime">{{ (row.stopTime || row.endTime) | fmtTime }}</el-row>
        </template>
      </el-table-column>
      <el-table-column :filters="dictEnum.RpClass" :filter-multiple="false" column-key="rpClass" align="center" width="100" label="处方类型" prop="rpClass"></el-table-column>
    </hic-table>

    <LogDialog :visible.sync="showLogDlg" :advice="curr" @backed="$emit('backed')" />
  </el-container>
</template>
<script>
  import { mapGetters } from "sw-hic";
  import api from "./api";

  export default {
    props: {
      hospitalization: Object,
      condition: Object,
      action: String,
      isEmbed: Boolean,
      readonly: Boolean,
    },
    components: {
      DrugInfo: () => import("./_infoDrug"),
      MlInfo: () => import("./_infoMl"),
      HerbalInfo: () => import("./_infoHerbal"),
      LogDialog: () => import("./dlgLog"),
    },
    data() {
      return {
        showLogDlg: false,
        loading: false,
        curr: null,
        entities: {
          items: [],
        },
        selection: [],
        filterStates: ["待校对", "启用", "待停止"],
      };
    },
    computed: {
      ...mapGetters(["dictEnum", "user", "setting"]),
      stateOptions() {
        if (this.hospitalization?.state == "已离院" || this.hospitalization?.state == "已结算") return [];
        if (this.action != "全 部") return [];
        return this.dictEnum.AdviceState;
      },
      myEntities() {
        if (!this.entities) return {};
        return this.entities;
      },
    },
    methods: {
      page() {
        // if (!this.condition.hospitalizationId) {
          this.condition.deptCode = this.user.deptCode;
        // } else {
        //   this.condition.deptCode = null;
        // }

        this.loading = true;
        (() => {
          if (this.action == "执行" || this.action == "确认停止") {
            this.condition.states = null;
            return api.Advice.queryForAction(this.action, this.condition);
          }
          if (this.action == "全 部") {
            if (!this.condition.states || !this.condition.states.length) {
              this.condition.states = this.filterStates;
            } else {
              this.filterStates = this.condition.states;
            }
          } else if (this.action == "校对") {
            this.condition.states = ["待校对"];
          }
          if (this.hospitalization?.state == "已离院") {
            this.condition.states = ["停止"];
          }
          return api.Advice.query(this.condition);
        })()
          //api.Advice.queryForAction(this.action, this.condition)
          // api.Advice.query(this.condition)
          .then((res) => {
            this.entities = res;
          })
          .catch((err) => {
            this.$message.error(err.message || err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      selectionChange(val) {
        this.$set(this, "selection", val);
      },
      showLogs(row) {
        if (row.singleOrMaster) {
          this.curr = row;
        } else {
          this.curr = this.myEntities.items.find((el) => el.id == row.groupNo);
        }
        this.showLogDlg = true;
      },
      btnExecDisplay(row) {
        if (row.state != "启用") {
          return false;
        }
        if (row.startTime) {
          return this.$utils.Dt.isEarlierOrEqual(row.startTime, this.$utils.Dt.now(), "m");
        }
        return true;
      },
      btnStopDisplay(row) {
        if (row.state != "待停止") {
          return false;
        }
        if (row.endTime) {
          return this.$utils.Dt.isEarlierOrEqual(row.endTime, this.$utils.Dt.now(), "m");
        }

        return true;
      },
      btnProofDisplay(row) {
        return row.state == "待校对";
      },
      styleClass({ row, columnIndex }) {
        let cls = "";
        if (!columnIndex && row.groupNo) {
          cls += " advieGrp" + (Number(row.groupNo) % 10);
        }
        // if (row.state == "废弃" || row.state == "停止" || row.state == "暂停") {
        //   cls += " info";
        // } else if (row.state == "待校对") {
        //   cls += " warning";
        // } else if (row.state == "待停止") {
        //   cls += " danger";
        // }

        return cls;
      },
      selectable(row) {
        if (this.action == "执行" && (row.type == "离院" || row.type == "转科" || this.$utils.Dt.isSame(row.execTime, this.$utils.Dt.now(), "d"))) {
          return false;
        }
        return true;
      },
      exec(row) {
        if (row.type == "离院" || row.type == "转科") {
          this.$confirm(`请确认当前患者没有待处理的事务。患者将自动停止所有医嘱，解锁所有占用床位。后续无法对患者进行记账、修改信息、调整床位等任何操作。确定要继续执行 ${row.type} 操作吗？`, `${row.type}确认`, {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$emit("action", "执行", [row.id]);
            })
            .catch(() => {});
        } else {
          this.$emit("action", "执行", [row.id]);
        }
      },
      execCommand(cmd, row) {
        console.log(cmd, row);
      },
      canNotExec(row) {
        let isAutoExec = false;
        if (this.setting.adviceExecInfo) {
          isAutoExec = JSON.parse(this.setting.adviceExecInfo).execTime != null;
        }

        if (isAutoExec) {
          return row.execTime != null;
        } else {
          return this.$utils.Dt.isSame(row.execTime, this.$utils.Dt.now(), 'd');
        }
      },
    },
  };
</script>
<style>
  .advieGrp0 {
    border-left: 10px solid gold;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp1 {
    border-left: 10px solid cyan;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp2 {
    border-left: 10px solid salmon;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp3 {
    border-left: 10px solid cornflowerblue;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp4 {
    border-left: 10px solid greenyellow;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp5 {
    border-left: 10px solid skyblue;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp6 {
    border-left: 10px solid pink;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp7 {
    border-left: 10px solid khaki;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp8 {
    border-left: 10px solid powderblue;
    /* border-right: 1px solid goldenrod; */
  }

  .advieGrp9 {
    border-left: 10px solid moccasin;
    /* border-right: 1px solid goldenrod; */
  }
</style>
